module.exports = __webpack_public_path__ + "img/20201022_executive_seminar_technologies_in_finance.dee3cf96.jpg";